import React from 'react';

const Teacher = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_4418_7041)">
        <path
          d="M12.0101 16.9993C11.1601 16.9993 10.3001 16.7793 9.63007 16.3493L3.61007 12.4193C2.49007 11.6893 1.82007 10.4593 1.82007 9.1193C1.82007 7.7793 2.49007 6.5493 3.61007 5.8193L9.64007 1.8993C10.9801 1.0293 13.0701 1.0293 14.4001 1.9093L20.3901 5.8393C21.5001 6.5693 22.1701 7.7993 22.1701 9.1293C22.1701 10.4593 21.5001 11.6893 20.3901 12.4193L14.4001 16.3493C13.7301 16.7893 12.8701 16.9993 12.0101 16.9993ZM12.0101 2.7493C11.4401 2.7493 10.8701 2.8793 10.4601 3.1593L4.44007 7.0793C3.74007 7.5393 3.33007 8.2793 3.33007 9.1193C3.33007 9.9593 3.73007 10.6993 4.44007 11.1593L10.4601 15.0893C11.2901 15.6293 12.7501 15.6293 13.5801 15.0893L19.5701 11.1593C20.2701 10.6993 20.6701 9.9593 20.6701 9.1193C20.6701 8.2793 20.2701 7.5393 19.5701 7.0793L13.5801 3.1493C13.1601 2.8893 12.5901 2.7493 12.0101 2.7493Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M11.9999 22.7501C11.5599 22.7501 11.1099 22.6901 10.7499 22.5701L7.55994 21.5101C6.04994 21.0101 4.85994 19.3601 4.86994 17.7701L4.87994 13.0801C4.87994 12.6701 5.21994 12.3301 5.62994 12.3301C6.03994 12.3301 6.37994 12.6701 6.37994 13.0801L6.36994 17.7701C6.36994 18.7101 7.14994 19.7901 8.03994 20.0901L11.2299 21.1501C11.6299 21.2801 12.3699 21.2801 12.7699 21.1501L15.9599 20.0901C16.8499 19.7901 17.6299 18.7101 17.6299 17.7801V13.1401C17.6299 12.7301 17.9699 12.3901 18.3799 12.3901C18.7899 12.3901 19.1299 12.7301 19.1299 13.1401V17.7801C19.1299 19.3701 17.9499 21.0101 16.4399 21.5201L13.2499 22.5801C12.8899 22.6901 12.4399 22.7501 11.9999 22.7501Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M21.3999 15.75C20.9899 15.75 20.6499 15.41 20.6499 15V9C20.6499 8.59 20.9899 8.25 21.3999 8.25C21.8099 8.25 22.1499 8.59 22.1499 9V15C22.1499 15.41 21.8099 15.75 21.3999 15.75Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_7041">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Teacher;
